// External Imports
import { h } from 'preact';
import FooterContent from '@lessonnine/footer-content-lib.js';
import {
  Footer as DSFooter,
  IconFacebookLogoFilled,
  IconInstagramLogoFilled,
  IconLinkedinLogoFilled,
  IconTwitterLogoFilled,
  IconYoutubeLogoFilled,
  Inline,
  Text,
} from '@lessonnine/design-system.lib';

// Component Definition
function Footer() {
  const locale = process.env.LOCALE;
  const footerContent = new FooterContent({ locale });

  const socialIcons = {
    facebook: <IconFacebookLogoFilled />,
    instagram: <IconInstagramLogoFilled />,
    linkedin: <IconLinkedinLogoFilled />,
    twitter: <IconTwitterLogoFilled />,
    youtube: <IconYoutubeLogoFilled />,
  };

  return (
    <DSFooter>
      <DSFooter.Section sectionName="primary">
        <Inline as="ul" padding="0" wrap>
          {footerContent.getPrimaryContent().map((content) => (
            <Inline as="li" key={content.id}>
              <DSFooter.Link href={content.href} id={content.id} sectionName="primary">
                {content.title}
              </DSFooter.Link>
            </Inline>
          ))}
        </Inline>
      </DSFooter.Section>
      <DSFooter.Section sectionName="secondary">
        <Inline as="ul" padding="0" wrap>
          {footerContent.getSecondaryContent().map((content) => (
            <Inline as="li" key={content.id}>
              <DSFooter.Link href={content.href} id={content.id} sectionName="secondary">
                <Text fontWeight={600}>{content.title}</Text>
              </DSFooter.Link>
            </Inline>
          ))}
        </Inline>
      </DSFooter.Section>
      <DSFooter.Section sectionName="icon">
        <Inline as="ul" padding="0" wrap>
          {footerContent.getIconContent().map((content) => (
            <Inline as="li" key={content.id}>
              <DSFooter.Icon
                href={content.href}
                icon={socialIcons[content.id]}
                id={content.id}
                rel="noopener"
                title={content.title}
              />
            </Inline>
          ))}
        </Inline>
      </DSFooter.Section>
    </DSFooter>
  );
}

export { Footer };
